import React from 'react';
import { content, SupportedLocale } from '../lib/content';

type WhyMeProps = {
  locale?: SupportedLocale;
};

export const WhyMe: React.FC<WhyMeProps> = ({ locale = 'pl' }) => {
  const t = content[locale].whyMe;

  return (
    <section id={t.id} className="whyme reveal">
      <div className="container">
        <div className="section-heading">
          <h2>{t.title}</h2>
        </div>
        <p className="section-intro">{t.lead}</p>
        <div className="whyme-grid">
          {t.usps.map((usp) => (
            <div className="card usp-card" key={usp.title}>
              <h3>{usp.title}</h3>
              <p>{usp.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
